module.exports = __webpack_public_path__ + "img/modifications--without_mattras.17493bc2.png";